import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import { sdsColors } from '../theme/solutionsDesignSystem';

// The visitor's own message bubble in the DQ Agent chat panel — the reply-side
// counterpart to PbdqChatMessage, right-aligned in the DQ accent color.
const useStyles = makeStyles(() => ({
    bubble: {
        maxWidth: 432,
        background: sdsColors.accent,
        color: '#fff',
        padding: '14px 18px',
        fontSize: 14.5,
        lineHeight: '23px',
        justifySelf: 'end',
        margin: 0,
        borderRadius: 14,
    },
}));

const PbdqChatUserMessage = ({ children }) => {
    const classes = useStyles();

    return <div className={classes.bubble}>{children}</div>;
};

export default PbdqChatUserMessage;
